import * as type from './types';

export function loginUser(user) {
    return {
        type: type.LOGIN_SUCCESS,
        payload: user,
    };
}

export function logoutUser() {
    return {
        type: type.LOGOUT,
    };
}

export function updateUser(user) {
    return {
        type: type.UPDATE_USER,
        payload: user,
    };
}

export function updateError(error) {
    return {
        type: type.ERROR,
        payload: error,
    };
}

export const registerUser = (profile) => ({
    type: type.REGISTER_USER,
    payload: profile,
});

export function sendPasswordResetEmailAction(email) {
    return {
        type: type.SEND_PASSWORD_RESET_EMAIL,
        payload: email,
    };
}
